export default __webpack_public_path__ + "static/media/header-img.239a0e64.png";